import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './page-appear-effect.module.css';

const EFFECT_COUNT = 3;

const createListBlock = (down?: boolean) => Array.from({ length: EFFECT_COUNT }).map(
  (thisItem, thisItemIndex) => (
    <div
      key={`${down ? 'top' : 'down'}_${thisItemIndex}`}
      className={down ? styles.top : styles.down}
      style={{
        '--index': thisItemIndex,
        backgroundColor: `hsl(0deg 0% ${88 - thisItemIndex * 11}%)`,
      } as React.CSSProperties}
    />
  ),
).reverse();

const PageAppearEffect: React.FunctionComponent = () => {
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => setLoaded(true), []);

  return (
    <div
      className={classNames(
        styles.component,
        {
          [styles.isLoaded]: isLoaded,
        },
      )}
    >
      {createListBlock()}
      {createListBlock(true)}
    </div>
  );
};

export default PageAppearEffect;
